import { IPDASetting } from '../../../models/IPDASetting.model';
import { Actions, GetPDASettings } from './pdaSettingsActions';
import { PDASettingsConstants } from './pdaSettingsConstants';
import { Dispatch } from 'redux';
import { PdaSettingsService } from '../../../services/pdaSettingsService';

export function createGetPdaSettingsRequest(): GetPDASettings {
  return {
    type: PDASettingsConstants.GET_PDA_SETTINGS_REQUEST,
  };
}

export function createGetPdaSettingsSuccess(
  payload: Array<IPDASetting>,
): GetPDASettings.Success {
  return {
    type: PDASettingsConstants.GET_PDA_SETTINGS_SUCCESS,
    payload,
  };
}

export function createGetPdaSettingsFailure(
  error: Error,
): GetPDASettings.Failure {
  return {
    type: PDASettingsConstants.GET_PDA_SETTINGS_FAILURE,
    error,
  };
}

export function getPdaSettings(
  ignoreCache = false,
): (dispatch: Dispatch<Actions>) => Promise<void> {
  return async function (dispatch) {
    dispatch(createGetPdaSettingsRequest());
    try {
      const response = await PdaSettingsService.GetPdaSettings(ignoreCache);
      dispatch(createGetPdaSettingsSuccess(response));
    } catch (error) {
      console.error(error);
      dispatch(createGetPdaSettingsFailure(error));
    }
  };
}
